import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    --white:#fff;
    --black:#000;
    --blue :#0061fe;
    --lightBlue :#D5E9FB;
    --blueHover :#1565c0;
    --orange:#f39c12;
    --orangeHover:#c9861a;
    --green:#86b820;
    --gray:#f2f2f7;
    --darkGray:#595959;
    --lightGray:#f7f7fd;
    --red:#ea4035;
    --bronze:#d2ad8e;
    --silver:#a3a3a3;
    --gold:#edba1d;
    --shop:#65ca99;
    --bundle:#f1be48;
    --elas:#204b70;
    --turbo:#ff3951;
    --credit:#6577ca;
    --premium:#ffa001;
    --bumpup:#0e91f9;
    --wa:#25D366;
    --fb:#4267b2;
    --email:#47c1c1;
    --copy:#646464;
    --sms:#323050;
    --phone:#039be5;
    --yellow:#FECE00;
  }
  .whiteColor {color:var(--white)}
  .whiteBg,.whiteBtn,.grayBorderBtn{background-color:var(--white)}
  .yellowBg{background-color:var(--yellow)}
  .blackColor,.whiteBtn.blackColor,.whiteBtn-2.blackColor{color:var(--black)}
  .blackBg{background-color:var(--black)}
  .grayColor{color:var(--gray)}
  .darkGrayColor{color:var(--darkGray)}
  .grayBg,.grayHoverBg:hover{background-color:var(--gray)}
  .blueBorder{border:1px solid var(--blue)}
  .darkGrayBg,.grayBtn{background-color:var(--darkGray)}
  .lightGrayColor{color:var(--lightGray)}
  .lightGrayBg,.lightGrayBtn{background-color:var(--lightGray)}
  .blueColor, a,.linkColor,.blueHoverText:hover{color:var(--blue)}
  .blueBg,.blueHoverBg:hover,.blueBtn{background-color:var(--blue)}
  .lightBlueBg{background-color:var(--lightBlue)}
  @media (hover: hover) {.blueBg:hover, .blueBtn:hover {background-color: var(--blueHover)}}
  .orangeColor{color:var(--orange)}
  .orangeBg,.orangeBtn{background-color:var(--orange)}
  .orangeBg:hover,.orangeBtn:hover{background-color:var(--orangeHover)}
  .greenBg,.greenBtn{background-color:var(--green)}
  .greenColor{color:var(--green)}
  .redColor{color:var(--red)}
  .redBg{background-color:var(--red)}
  .waColor{color:var(--wa)}
  .waBg,.waBtn{background-color:var(--wa)}
  .fbColor{color:var(--fb)}
  .fbBg,.fbBtn{background-color:var(--fb)}
  .emailColor{color:var(--email)}
  .emailBg{background-color:var(--email)}
  .copyColor{color:var(--copy)}
  .copyBg{background-color:var(--copy)}
  .smsColor{color:var(--sms)}
  .smsBg{background-color:var(--sms)}
  .phoneColor{color:var(--phone)}
  .phoneBg{background-color:var(--phone)}
  .blueHoverBg:hover > svg path{fill:#fff}
  .blueHoverBg:hover{color:#fff}
  [class*="HoverBg"]{transition: 0.1s}
  html {
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased
  }
  body {
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth
  }
  *, body, ul, ol, h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }
  body, button, h1, h2, h3, input, select, td, textarea, th{
    font-size: 16px;
    text-rendering: optimizeLegibility;
    line-height:100%
  }
  *, *:before, *:after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: transparent
  }
  * {direction: ${({ theme: { direction } }) => direction}}
  *[class*="-root"]{font-family: "Vazirmatn", sans-serif !important}
  .normalFont {font-weight: normal}
  a,.linkColor {
    text-decoration: none;
    outline: 0
  }
  a:hover {text-decoration: none}
  .noClick {pointer-events: none !important}
  a:hover, input[type="submit"]:hover, input[type="button"]:hover, button:hover,label:hover,.pointer {cursor: pointer}
  .noSelection{
    -webkit-user-select:none;
    -webkit-touch-callout:none;
  }
  input[type="submit"], input[type="button"], button,[class*="Btn"]{
    border-radius:8px;
    text-align: center;
    border:0;
  }
  input[type="submit"]:not(.noRipple), input[type="button"]:not(.noRipple), button:not(.noRipple),[class*="Btn"]:not(.noRipple),.ripple{
    position:relative;
    overflow:hidden;
    transform: translate3d(0,0,0);
  }
 .boxShadow{filter: drop-shadow(0px 1px 8px rgba(0, 0, 0, 0.16))}
 .boxShadow2{  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);}
 .btnShadow{box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)}
 .fullShadow{box-shadow:0 1px 18px rgba(0, 0, 0, 0.1)}
  input[type="submit"]:not(.noRipple):after, input[type="button"]:not(.noRipple):after, button:not(.noRipple):after,[class*="Btn"]:not(.noRipple):after,.ripple:after{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background-image: radial-gradient(circle,#000 10%,transparent 10.01%);
    background-repeat: no-repeat;
    background-position: 50%;
    transform: scale(10);
    opacity: 0;
    transition: transform .2s,opacity 1s;
  }
  input[type="submit"]:active:after, input[type="button"]:active:after, button:active:after,[class*="Btn"]:active:after,.ripple:active:after{
    transform:scale(0, 0);
    opacity:0.2;
    transition:0s
  }
  .orangeBtn,.greenBtn,.grayBtn,.blueBtn,.whiteBtn-3,.whiteBtn,.whiteBtn-2,.fbBtn,.waBtn {
    color: #fff;
    border-radius: 8px;
    text-align: center;
    font-weight: bold;
    ${({ theme: { isMobile } }) => isMobile && `width: 100%`}
  }
  .orangeBtn,.greenBtn,.grayBtn,.blueBtn,.fbBtn,.waBtn{border:1px solid transparent}
  .whiteBtn,.whiteBtn-2{
    color: #0061FE;
    background-color: #fff;
  }
  .whiteBtn{border: 2px solid #0061FE}
  .whiteBtn-2{border: 1px solid #dcdcdc}
  .whiteBtn-3{
  border:2px solid #57585A;
  color:#57585A
  }
  .whiteBtn svg path{fill:#0061FE}
  .whiteBtn:hover{background-color:#f6fafd}
  .disabled,.disabledText,button:disabled {
    color: #57585A !important;
    pointer-events: none !important;
    border: 1px solid transparent;
    cursor:grab !important;
  }
  .disabled,button:disabled {
    box-shadow: none;
    background-color: #979592 !important
  }
  button:disabled svg path:not(:last-child),button:disabled svg path:only-child,.disabled svg path,.disabled svg path:only-child {
    color:#57585A !important;
    fill:#57585A !important
  }
  input:-webkit-autofill {-webkit-box-shadow: 0 0 0 1000px white inset}
  ul {list-style: none}
  ul, ol {list-style-position: inside}
  .listTypeDisc {list-style-type: disc}
  p{line-height: 1.5em}
  img {
    max-width: 100%;
    object-fit: cover;
  }
  .noImgFit {object-fit:unset}
  button, fieldset, img ,input,select{
    border: 0;
    background-color: transparent;
    outline: 0;
  }
  svg {overflow: visible}
  svg[data-flip-top="true"]{transform: scaleY(-1)}
  ${({ theme: { isLTR } }) => isLTR && ` svg[data-flip="true"] {transform: scaleX(-1)}`}
  ${({ theme: { isMobile } }) => isMobile && `.mobileCardBorder{border-bottom: 8px solid var(--gray)}`}
  select, textarea, button, input[type=submit], input[type=button] { appearance: none }
  input:focus, textarea:focus {outline: 0}
  ::-webkit-input-placeholder {color: #57585a}
  ::-moz-placeholder {color: #57585a}
  :-ms-input-placeholder {color: #57585a}
  .ta-s{text-align: ${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}}
  .ta-e{text-align: ${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}}
  .float-s{float:${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}}
  .float-e{float:${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}}
  .clear {clear: both}
  .center {text-align: center}
  .contentVisibilityHidden{content-visibility: hidden}
  .pageMoved .contentVisibilityHidden{content-visibility: unset}
  .overflowHidden {overflow: hidden}
  .overflowVisible {overflow: visible}
  .overflowHidden-x,.ssr {overflow-x: hidden}
  .overflowX-scroll {overflow-x: scroll}
  .overflowY-scroll {overflow-y: scroll}
  .overflowX-scroll,.overflowY-scroll{scroll-behavior: smooth}
  section,.block {display: block}
  .forceHide{display:none !important}
  .inline {display: inline-block}
  .underline{text-decoration:underline}
  .italic{font-style:italic}
  .lineThrough{text-decoration:line-through}
  .bold {font-weight: bold}
  .fullRadius{border-radius:100%}
  .radius-8{border-radius:8px}
  .radius-0,[class*="Btn"].radius-0{border-radius:0}
  .ltr{direction:ltr}
  .breakWord{word-break:break-word}
  .breakAll{word-break:break-all}
  .wrap{white-space:normal}
  .noWrap{white-space:nowrap}
  .flex{display:flex}
  .flexWrap{flex-wrap:wrap}
  .flexNoWrap{flex-wrap:nowrap}
  .flex-1{flex:1}
  .flexRow{flex-flow:row wrap}
  .alignSelfCenter{align-self:center}
  .alignSelfStart{align-self:flex-start}
  .justifyContent{justify-content:center}
  .alignItems{align-items: center}
  .alignItemsStart{align-items: flex-start}
  .alignItemsEnd{align-items: flex-end}
  .flexSpaceBetween{justify-content:space-between}
  .flexSpaceAround{justify-content:space-around}
  .spaceEvenly{justify-content:space-evenly}
  .flexDirectionColumn{flex-direction:column}
  .flexDirectionRow{flex-direction:row}
  .flexDirectionRowReverse{flex-direction:row-reverse}
  .flexDirectionColumnReverse{flex-direction:column-reverse}
  .flexEnd{justify-content:end}
  .table{
    display:table;
    width:100%
  }
  .equalTable{table-layout:fixed}
  .tableCell{
    display:table-cell;
    vertical-align:middle
  }
  .tableRow{
    display:table-row;
    border-collapse:collapse
  }
  .hide{display:none}
  .vTop{vertical-align:top}
  .vMiddle{vertical-align:middle}
  .vBottom{vertical-align:bottom}
  .vTextTop{vertical-align:text-top}
  .vSub{vertical-align:sub}
  .vSup{vertical-align:super}
  .relative {position: relative}
  .absolute {position: absolute}
  .fixed{
  position:fixed;
  position:-ms-device-fixed;
  -webkit-backface-visibility:hidden;
  backface-visibility:hidden;
  z-index: 2;  
  }
  .bottom-0{
  bottom:0;
  left:0;
  z-index:1;
  overflow: hidden;
  }
  .sticky{
  position:-webkit-sticky;
  position:sticky;
  top:0;
  z-index:2
  }
  .trim {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width:95%  
  }
  .trimTwoLines {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4em;
  }
  .centerPosition {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto
  }
  .centerPosition1{
    position:absolute;
    top:50%;
    left:50%;
    transform:translateX(-50%) translateY(-50%)
  }
  .width-fit{width:fit-content}
  ${({ theme: { isDesktop } }) =>
    isDesktop &&
    `
  .width-1200{width:1200px}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* CSS styles specific to iPads in landscape mode */
  /* Add your styles here */
  .width-1200{width:100%; padding-right:8px ;padding-left:8px}
  #pageContent{padding:0 16px}
  #pageContent img{max-width:100%}
  }
  `}
  .width-100{width:100%}
  .width-49{width:49%}
  .width-20{width:20%}
  .width-25{width:25%}
  .width-30{width:30%}
  .width-33{width:33%}
  .width-40{width:40%}
  .width-45{width:45%}
  .width-50{width:50%}
  .width-60{width:60%}
  .width-70{width:70%}
  .width-75{width:75%}
  .width-90{width:90%}
  .width-auto{width:auto}
  .width-100vw{width:100vw}
  .height-100{height:100%}
  .height-100vh{height:100vh}
  .height-auto{height:auto}
  .height-50{height:50px}
  .height-55{height:55px}
  .m-0 {margin: 0}
  .m-auto {margin: auto}
  .mt-auto {margin-top:auto}
  .mb-auto {margin-bottom: auto}
  .ms-auto {margin-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}: auto}
  .me-auto {margin-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}: auto}
  .m-8{margin:8px}
  .ms-8 {margin-${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}: 8px}
  .me-8 {margin-${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}: 8px}
  .ms-16 {margin-${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}: 16px}
  .me-16 {margin-${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}: 16px}
  ${({ theme: { isDesktop, isRTL } }) => isDesktop && `.ms-32 {margin-${isRTL ? "right" : "left"}: 32px}`}
  ${({ theme: { isDesktop, isRTL } }) => isDesktop && `.me-32 {margin-${isRTL ? "left" : "right"}: 32px}`}
  .mt-8{margin-top:8px}
  .mb-8{margin-bottom:8px}
  .mt-16{margin-top:16px}
  .mb-16{margin-bottom:16px}
  .mt-32{margin-top:32px}
  .mb-32{margin-bottom:32px}
  .ps-8 {padding-${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}: 8px}
  .pe-8 {padding-${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}: 8px}
  .ps-16 {padding-${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}: 16px}
  .pe-16 {padding-${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}: 16px}
  .ps-32 {padding-${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}: 32px}
  .pe-32 {padding-${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}: 32px}
  .p-8{padding:8px}
  .p-16{padding:16px}
  .p-32{padding:32px}
  .pt-8{padding-top: 8px}
  .pb-8{padding-bottom: 8px}
  .pt-16{padding-top: 16px}
  .pb-16{padding-bottom: 16px}
  .pt-32{padding-top:32px}
  .pb-32{padding-bottom:32px}
  .p-0{padding:0}
  .pt-0{padding-top: 0}
  .pb-0{padding-bottom: 0}
  .ps-0{padding-${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}: 0}
  .pe-0{padding-${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}: 0}
  .pt-5{padding-top:5px}
  .border{border:1px solid #dcdcdc}
  .borderBlack{border:1px solid #000}
  .hasError{border:1px solid var(--red)}
  .borderTop{border-top:1px solid #dcdcdc}
  .borderBottom{border-bottom:1px solid #dcdcdc}
  .borderTopDashed{border-top:1px dashed #dcdcdc}
  .borderBottomDashed{border-bottom:1px dashed #dcdcdc}
  .borderBottomLightGray{border-bottom : 1px solid #F2F2F7}
  .borderTopLightGray{border-top : 1px solid #F2F2F7}
  .borderLightGray{border : 1px solid #F2F2F7}
  .border-s{border-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}:1px solid #dcdcdc}
  .border-e{border-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}:1px solid #dcdcdc}
  .border-0,hr,[class*="Btn"].border-0{border:none}
  hr{height:1px}  
  .font-12{font-size:0.75em}
  .font-13{font-size:0.8125em}
  .font-14{font-size:0.875em}
  .font-15{font-size:0.938em}
  .font-16{font-size:1em}
  .font-17{
  font-size:1.0625em;
  line-height:1.1625em
  }
  .font-18{
    font-size:1.125em;
    line-height:1.150em
  }
  .font-19{
    font-size:1.1875em;
    line-height:1.1875em
  }
  .font-20{
    font-size:1.250em;
    line-height:1.250em
  }
  .font-21{
    font-size:1.3125em;
    line-height:1.3125em
  }
  .font-22{
    font-size:1.375em;
    line-height:1.4em
  }
  .font-23{
    font-size:1.3750em;
    line-height:1.3750em
  }
  .font-24{
    font-size:1.5em;
    line-height:1.5em;
  }
  .font-26{
    font-size:1.62em;
    line-height:1.5em;
  }
  .font-30{
    font-size:1.875em;
    line-height:1.89em;
  }
  .font-32{
    font-size:2em;
    line-height:2em;
  }
  .font-36{
    font-size:2.25em;
    line-height:1.5em;
  }
  .font-40{
    font-size:2.5em;
    line-height:1.5em;
  }
  .gap-5{gap: 5px}
  .gap-10{gap: 10px}
  .gap-15{gap: 15px}
  .gap-20{gap: 20px}
  .gap-25{gap: 25px}
  .gap-30{gap: 30px}
  .gap-40{gap: 40px}
  .rotateUp {
    transform: rotate(180deg);
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
  }
  .scale13{transform:scale(1.3)}
  .scale14{transform: scale(1.4)}
  .scale15{transform:scale(1.5)}
  .animatedFade{animation: fadeIn .7s}
  @keyframes fadeIn {
    0% { opacity: 0}
    100% {opacity: 1}
  }
  .shimmerEffect {
    animation: shimmer 2.5s infinite linear;
    background: linear-gradient(to right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 36%);
    background-size: 1000px 100%;
    transition: 0.3s;
  }
  @keyframes shimmer {
    0% {background-position: -1000px 0}
    100% {background-position: 1000px 0}
  }
  .shineEffect:before {
    content: "";
    position: absolute;
    background: #fff;
    width: 4px;
    top: -10px;
    bottom: -10px;
    left: -40px;
    transform: rotate(25deg);
    box-shadow: 0 0 20px #fff;
    filter: blur(3px);
    transition: 1s;
    animation: shineEffectFrame 1s infinite ease-in-out;
  }
  @keyframes shineEffectFrame {
    from {left: -40px}
    to {left: calc(100% + 2px)}
    }
  .z-index-100{z-index:100}
  .visible_on_ssr_block,.visible_on_ssr_flex ,.ssr .hidden_on_ssr ,.ssr .hidden_on_ssr_block {display: none}
  .ssr .visible_on_ssr_block ,.hidden_on_ssr_block{display: block}
  .ssr .visible_on_ssr_flex {display: flex}
  .isDarkMode,.isDarkMode .whiteBg ,.isDarkMode .aboutOS,.isDarkMode .darkGrayColor,.isDarkMode input{
    background: #000 !important;
    color:#fff !important;
  }
  .isDarkMode a:not(.whiteBtn),.isDarkMode label ,.isDarkMode ::placeholder{color:#fff !important}
  .isDarkMode .nativeAutoCompleteList{
    border:1px solid #fff;
    border-radius:8px
  }
  .isDarkMode .infoList svg path{fill: #fff}
  .webView::-webkit-scrollbar {width: 6px}
  .webView::-webkit-scrollbar-track {
    background-color: white;
    border-radius: 20px;
    margin-top: 5px;
  }
  .webView::-webkit-scrollbar-thumb {
    border-radius: 15px;
    background-color: #c8c8ce;
  }
  .webView::-webkit-scrollbar-thumb:hover {background-color: #88898c}
`;
export default GlobalStyle;